var eskape = require('eskape');

module.exports = function reactEscapeHTML() {
  return { __html: eskape.apply(undefined, arguments) };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-escape-html/index.js
// module id = 83
// module chunks = 0